<template>
    <div>
        <div class="custom-search d-flex justify-content-between">
            <div>
                <b-button
                        id="importExcelButton"
                        variant="success"
                        class="mr-1"
                        v-if="$acl.canCreatePermission(role)"
                        @click="$router.push({name: 'fishermen-import'})"
                >
                    Importálás
                </b-button>
                <b-button
                        id="excelExportButton"
                        :disabled="!rows.length"
                        variant="warning"
                        @click="exportData"
                >
                    Exportálás
                </b-button>
            </div>
            <b-form-group>
                <div class="d-flex align-items-center">
                    <label class="mr-1">Keresés</label>
                    <b-form-input
                            v-model="searchTerm"
                            placeholder="Keresés..."
                            type="text"
                            class="d-inline-block"
                            @input="globalSearch"
                    />
                </div>
            </b-form-group>
        </div>

        <!-- table -->
        <vue-good-table
                mode="remote"
                :columns="columns"
                :rows="rows"
                :rtl="direction"
                :pagination-options="{
          enabled: true,
          perPage: pageLength
        }"
                :sort-options="{
          enabled: true,
          initialSortBy: sortBy
        }"
                @on-row-click="onRowClick"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
        >
            <div slot="emptystate">
                <div class="vgt-center-align vgt-text-disabled">
                    {{ $t('table.list.empty') }}
                </div>
            </div>
            <template
                    slot="table-row"
                    slot-scope="props"
            >

                <!-- Column: Name -->
                <span
                        v-if="props.column.field === 'name'"
                        class="text-nowrap"
                >
                <span class="text-nowrap">{{ props.row.name }}</span>
              </span>

                <span
                        v-else-if="props.column.field === 'nationality'"
                        class="text-nowrap"
                >
                <span class="text-nowrap" v-if="props.row.nationality && props.row.nationality !== 'UNKNOWN'">{{
                        nationalities.getName(props.row.nationality, "hu")
                    }} ({{ props.row.nationality }})</span>
                <span class="text-nowrap" v-else>Ismeretlen</span>
              </span>

                <!-- Column: Action -->
                <span v-else-if="props.column.field === 'action'">
                <b-button
                        v-b-tooltip.hover
                        title="Rekordlista szűrése erre a horgászra"
                        size="sm"
                        variant="info"
                        @click.stop="searchRecordCatch(props.row.id)"
                >
                    <feather-icon
                            icon="SearchIcon"
                    />
                  </b-button>
                <span v-if="$acl.canEditPermission(role)">
                  <b-button
                          v-b-tooltip.hover
                          title="Szerkesztés"
                          size="sm"
                          variant="primary"
                          class="ml-1"
                          @click.stop="$router.push({ name: 'modify-fisherman', params: { id: props.row.id }})"
                  >
                    <feather-icon
                            icon="EditIcon"
                    />
                  </b-button>
                </span>
                <span v-if="$acl.canDeletePermission(role)">
                  <b-button
                          v-b-tooltip.hover
                          title="Törlés"
                          size="sm"
                          variant="danger"
                          class="ml-1"
                          @click.stop="deleteEntity(props.row.id, $event, props.row.record_catch_count === 0)"
                  >
                    <feather-icon
                            icon="XCircleIcon"
                    />
                  </b-button>
                </span>
              </span>

                <!-- Column: Common -->
                <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <!-- pagination -->
            <template
                    slot="pagination-bottom"
                    slot-scope="props"
            >
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              {{ ((page - 1) * pageLength) + 1 }} +
            </span>
                        <b-form-select
                                v-model="pageLength"
                                :options="pages"
                                class="mx-1"
                                @change="handlePageChange"
                        />
                        <span class="text-nowrap "> a {{ dataFromServer.total }} találatból </span>
                    </div>
                    <div>
                        <b-pagination
                                :value="1"
                                :total-rows="dataFromServer.total"
                                :per-page="dataFromServer.per_page"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="mt-1 mb-0"
                                @change="handleChangePage"
                        >
                            <template #prev-text>
                                <feather-icon
                                        icon="ChevronLeftIcon"
                                        size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                        icon="ChevronRightIcon"
                                        size="18"
                                />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
import {
    BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BButton, VBTooltip,
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import store from '@/store'
import moment from "moment";
import FileSaver from 'file-saver'

export default {
    components: {
        VueGoodTable,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BButton,
        VBTooltip,
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    data() {
        return {
            role: 'fisherman',
            pageLength: 10,
            dir: false,
            pages: ['10', '20', '50'],
            columns: [
                {
                    label: this.$t('form.id'),
                    field: 'id',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Azon. szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: this.$t('form.name'),
                    field: 'name',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Név szerinti szűrés',
                    },
                },
                {
                    label: this.$t('table.header.nationality'),
                    field: 'nationality',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Ország szerinti szűrés',
                    },
                },
                {
                    label: 'Rekordfogások száma',
                    field: 'record_catch_count',
                    sortable: true,
                    filterOptions: {
                        placeholder: 'Rekordfogások száma szerinti szűrés',
                        enabled: true,
                    },
                },
                {
                    label: 'Tulajdonos felhasználó',
                    field: 'owner_user_name',
                    sortable: true,
                    filterOptions: {
                        placeholder: 'Tulajdonos felhasználó szerinti szűrés',
                        enabled: true,
                    },
                },
            ],
            rows: [],
            page: 1,
            dataFromServer: [],
            filterData: [],
            searchTerm: '',
            sortBy: {
                field: 'id',
                type: 'desc',
            },
            columnFilters: [],
            nationalities: '',
            forExcel: false,
            excel_data: {
                fields: {},
                data: [],
                worksheet_name: 'horgaszok',
                filename: 'fisherman_export',
                meta: [
                    [
                        {
                            key: 'charset',
                            value: 'utf-8',
                        },
                    ],
                ]
            }
        }
    },
    computed: {
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    created() {
        let storedPageLength = localStorage.getItem('pageLength')
        if (storedPageLength) {
            this.pageLength = storedPageLength
        }

        let storedSearchTerm = localStorage.getItem('fishermanSearchTerm')
        if (storedSearchTerm) {
            this.searchTerm = storedSearchTerm
        }

        let storedColumnFilters = localStorage.getItem('fishermanColumnFilters')
        if (storedColumnFilters) {
            this.columnFilters = JSON.parse(storedColumnFilters)
            Object.keys(this.columnFilters).forEach(key => {
                const value = this.columnFilters[key]
                const foundIndex = this.columns.findIndex(col => col.field === key)

                if (foundIndex !== -1) {
                    this.$set(this.columns[foundIndex].filterOptions, 'filterValue', value)
                }
            })
        }

        let nationalities = require("i18n-iso-countries")
        nationalities.registerLocale(require("i18n-iso-countries/langs/hu.json"));
        this.nationalities = nationalities

        if (this.$acl.canEditPermission(this.role) || this.$acl.canDeletePermission(this.role)) {
            const actions = [
                {
                    label: this.$t('table.header.actions'),
                    field: 'action',
                    sortable: false,
                    width: '15rem',
                },
            ]

            this.columns = [...actions, ...this.columns]
        }

        this.initEntities()
    },
    methods: {
        initEntities() {
            const searchParams = {
                page: parseInt(this.page),
                limit: parseInt(this.pageLength),
                query: this.searchTerm,
                columnFilters: this.columnFilters,
                sort: this.sortBy,
            }

            this.$store.dispatch('fetchFishermen', searchParams).then(response => {
                this.rows = response.data.entities.data
                this.dataFromServer = response.data.entities
                this.page = this.dataFromServer.current_page
                this.pageLength = parseInt(this.dataFromServer.per_page)
            })
        },
        searchRecordCatch(id) {
            let routeData = this.$router.resolve({name: 'record-catches', query: {fisherman_id: id}});
            window.open(routeData.href, '_blank');
        },
        onRowClick(params) {
            if (this.$acl.canEditPermission(this.role))
                this.$router.push({name: 'modify-fisherman', params: {id: params.row.id}})
        },
        handleChangePage(page) {
            this.page = page
            this.initEntities()
        },
        handlePageChange(active) {
            this.pageLength = active
            localStorage.setItem('pageLength', active)
            this.page = 1
            this.handleChangePage()
        },
        newEntity() {
            this.$router.push({name: 'add-fisherman'})
        },
        deleteEntity(id, event, deletable) {
            if (deletable) {
                this.$bvModal
                    .msgBoxConfirm('Biztosan törölni szeretnéd?', {
                        title: 'Jóváhagyás',
                        size: 'sm',
                        okVariant: 'primary',
                        okTitle: 'Igen',
                        cancelTitle: 'Nem',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then(value => {
                        if (value) {
                            // axios
                            this.$store.dispatch('deleteFisherman', id).then(() => {
                                this.initEntities(1)
                                this.$helpers.showSuccessToast(`A horgászt töröltük. (ID: ${id})`)
                            })
                        }
                    })
            } else {
                this.$helpers.showErrorToast('A horgász nem törölhető, mert vannak rekordfogásai.')
            }
        },
        globalSearch(params) {
            this.page = 1
            this.query = params.searchTerm
            localStorage.setItem('fishermanSearchTerm', this.searchTerm)
            this.initEntities()
        },
        onSortChange(params) {
            this.page = 1
            this.sortBy = params[0]
            this.initEntities()
        },
        onColumnFilter(params) {
            this.page = 1
            this.columnFilters = params.columnFilters
            localStorage.setItem('fishermanColumnFilters', JSON.stringify(this.columnFilters))
            this.initEntities()
        },
        exportData() {
            const searchParams = {
                page: parseInt(this.page),
                limit: parseInt(this.pageLength),
                query: this.searchTerm,
                columnFilters: this.columnFilters,
                sort: this.sortBy,
            }

            this.loading = true
            this.$store.dispatch('exportFishermenList', searchParams).then(response => {
                let filename = 'horgaszok-' + moment().format('YYYY-MM-DD-HH-mm') + '.xlsx'
                FileSaver.saveAs(response.data, filename)
            }).finally(() => {
                this.loading = false
            })
        }
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
